import PropTypes from 'prop-types'
import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

const KakaoWrap = ({ children }) => {
  const { classNames } = useSelector(state => state.layout)
  const [scrolled, setScrolled] = useState(false)
  const className = useMemo(() => {
    const baseClass = scrolled ? ['scrolling'] : []
    return baseClass.concat(classNames).join(' ')
  }, [scrolled, classNames])

  const handleScroll = () => {
    setScrolled(window.scrollY > 0)
  }

  useEffect(() => {
    document.addEventListener('scroll', handleScroll)
    return () => {
      document.removeEventListener('scroll', handleScroll)
    }
  })

  return (
    <div id="kakaoWrap" className={className}>
      {children}
    </div>
  )
}

KakaoWrap.propTypes = {
  children: PropTypes.node,
}
export default KakaoWrap
